export default "__VITE_ASSET__3e10afcd__"